import { Pipe, PipeTransform } from '@angular/core';

export function bytesToMb(v: number | string | undefined): number {
  if (!v) {
    return 0;
  }
  return (Number(v) / 1024 / 1024);
}

export function prepareSize(v: number | string | undefined): string {
  switch (true) {
    case !v: {
      return `0,0`;
    }
    case `${v}`.length < 4: {
      return `${Number(v).toFixed(1).replaceAll('.', ',')} bytes`;
    }
    case `${v}`.length >= 4: {
      return `${(Number(v) / 1024).toFixed(1).replaceAll('.', ',')} Kb`;
    }
    case `${v}`.length >= 7: {
      return `${bytesToMb(v).toFixed(1).replaceAll('.', ',')} Mb`;
    }
    default:
      return '0,0';
  }
}

@Pipe({
  name: 'fileSize',
  standalone: true
})
export class FileSizePipe implements PipeTransform {

  transform(value: number | undefined): string {
    return prepareSize(value);
  }

}
